// Fehlercodes des Servers (server/src/fehler.ts) → Text für Kunden.

import { ApiError, NetworkError } from "./api.ts";

const TEXT: Record<string, string> = {
  nicht_gefunden: "Dieser Link ist nicht (mehr) gültig. Bitte wenden Sie sich an Ihr Umzugsunternehmen.",
  bereits_abgesendet: "Diese Aufnahme wurde bereits abgeschickt.",
  unvollstaendig: "Es fehlen noch Angaben.",
  zu_viele_versuche: "Zu viele Versuche. Bitte warten Sie einen Moment.",
  demo_verbraucht: "Die Demo können Sie einmal am Tag ausprobieren. Registrieren Sie Ihre Firma, dann gibt es 3 kostenlose Aufnahmen für echte Kunden.",
  datei_ungueltig: "Das Foto konnte nicht gelesen werden. Bitte noch einmal aufnehmen.",
  datei_zu_gross: "Das Foto ist zu groß.",
  code_falsch: "Der Code stimmt nicht. Bitte noch einmal prüfen.",
  link_ungueltig: "Der Code ist abgelaufen oder wurde schon benutzt. Bitte einen neuen anfordern.",
  privat_voll: "Heute sind leider schon sehr viele Aufnahmen entstanden. Bitte versuchen Sie es morgen noch einmal.",
  auswertung_laeuft: "Die Auswertung läuft gerade. Bitte einen Moment warten.",
  pdf_fehler: "Das PDF konnte gerade nicht erstellt werden. Bitte später erneut versuchen.",
  eingabe_ungueltig: "Bitte die Eingabe prüfen.",
  play_kauf_ungueltig: "Der Kauf bei Google Play konnte nicht bestätigt werden. Bitte noch einmal versuchen; ein schon bezahlter Kauf wird dabei wiederverwendet.",
  keine_berechtigung: "Das ist hier nicht möglich.",
  serverfehler: "Bei uns ist ein Fehler aufgetreten. Ihre Angaben sind gespeichert; bitte später erneut versuchen.",
};

export function errorText(e: unknown): string {
  if (e instanceof NetworkError) return "Keine Internetverbindung. Ihre Angaben sind auf dem Handy gespeichert.";
  if (e instanceof ApiError) return TEXT[e.code] ?? TEXT.serverfehler!;
  return "Unerwarteter Fehler. Bitte die Seite neu laden – Ihre Angaben bleiben erhalten.";
}
